




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import GradeService from '../services/grade-service';
import LabelService from '@/shared/services/label-service';
import HttpService from '@/shared/services/http-service';

import ModuleInfo from './ModuleInfo.vue';
import Loader from '@/shared/components/Loader.vue';
import MessageComponent from '@/shared/components/Message.vue';

import { IDictionary } from '@/shared/models/interface/dictionary-model';
import { Label } from '@/shared/models/view/labels-viewmodel';
import { Config } from '../models/config-viewmodel';
import { ModuleDetail } from '../models/grade-viewmodels';
import { Popup } from '@/shared/models/view/popup-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';

import { formatDate } from '@/shared/filters/dates';

@Component({
    name: 'ModuleDetail',
    computed: {
        ...mapState(['result', 'config']),
        ...mapState('root', ['labels', 'popupComponent']),
        ...mapGetters('root', ['label'])
    },
    components: {
        ModuleInfo,
        Loader,
        MessageComponent
    },
    filters: {
        formatDate
    }
})
export default class ModuleDetailComponent extends Vue {
    public labels!: IDictionary<Label[]>;
    public loading = true;
    public config!: Config;
    public result!: ModuleDetail;
    private message: string = '';
    private popupComponent!: Popup;
    private labelModule = 'ModuleBooking';

    private loadData() {
        this.loading = true;
        this.message = '';
        Promise.all([
            GradeService.getGradeByStudy(
                this.config.language,
                this.config.vuNetIdStudent,
                this.popupComponent.data.studyId, 
                this.popupComponent.data.year,
                this.popupComponent.data.bookedModuleId,
                HttpService),
            LabelService.getLabelsByCategory(this.config.language, this.labelModule, HttpService)
        ])
        .then(values => {
            this.$store.commit('setModuleDetail', values[0]);
            this.$store.commit('root/setLabels', {labels: values[1], type: this.labelModule});
            this.loading = false;
        })
        .catch(error => {
            this.message = 'Er is iets fout gegaan bij het ophalen van de module details';
            this.loading = false;
        });
    }

    private setSessionStorage(): void {
        sessionStorage.setItem('studyInfo', `{"year": ${this.popupComponent.data.year}, "study": "${this.popupComponent.data.studyId}"}`);
    }

    @Watch('popupComponent') onPopupChanged() {
        this.loadData();
    }

    mounted() {
        this.loadData();
        this.setSessionStorage();
    }
}
